import React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../../../store';
import styles from './StatusInfo.module.scss';
import { IBusinessStatus, BusinessStatus, BusinessSubStatus } from '../../../../../api/define';

type StatusHeaderProps = {
    statusText: string;
    statusTag: string;
    businessStatusInfo: IBusinessStatus;
};

const { useMemo } = React;

const StatusHeader: React.FC<StatusHeaderProps> = ({
    statusText,
    statusTag,
    businessStatusInfo,
}) => {
    const { status, subStatus } = businessStatusInfo;

    /** tag标红 */
    const TagWarn = useMemo(() => {
        const result =
            status === BusinessStatus.REST ||
            (status === BusinessStatus.OPEN && subStatus === BusinessSubStatus.WILLOPEN)
                ? 1
                : 0;

        return result;
    }, [status, subStatus]);

    return (
        <div className={styles.menuItem}>
            <div className={styles.txt}>{statusText}</div>
            <div className={`${styles.tag} ${TagWarn ? styles.blockWarn : ''}`}>{statusTag}</div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        businessStatusInfo: state.shellHeader.poiBusinessStatus,
    };
};

export default connect(mapStateToProps)(StatusHeader);
